import React, { useRef, useState } from 'react';
import About from './about';
// import heroBg from '/qoncave-interior-design-hero.jpeg';

const Home = () => {
  const heroRef = useRef(null);
  const [currentCell, setCurrentCell] = useState(null);
  const [prevCell, setPrevCell] = useState(null);
  const gridCols = 18;
  const gridRows = 10;

  const handleMouseMove = (e) => {
    const rect = heroRef.current?.getBoundingClientRect();
    if (!rect) return;

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const col = Math.min(gridCols - 1, Math.max(0, Math.floor((x / rect.width) * gridCols)));
    const row = Math.min(gridRows - 1, Math.max(0, Math.floor((y / rect.height) * gridRows)));
    const nextCell = { col, row };

    if (!currentCell || currentCell.col !== col || currentCell.row !== row) {
      setPrevCell(currentCell);
      setCurrentCell(nextCell);
    }
  };

  const handleMouseLeave = () => {
    setCurrentCell(null);
    setPrevCell(null);
  };

  const scrollToNextSection = () => {
    const nextSection = document.getElementById('next-section');
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const backgroundStyle = {
    backgroundImage: `url(/qoncave-interior-design-hero.jpeg)`,
  };

  return (
    <div className='font-Poppins'>
      {/* Hero Section */}
      <div
        ref={heroRef}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        className="relative py-16 lg:mt-[-70px] md:py-52 flex flex-col justify-center items-center text-center text-white overflow-hidden"
      >
        {/* Background Image with Opacity */}
        <div
          className="absolute inset-0 bg-cover bg-center before:absolute before:inset-0 before:bg-black/20"
          style={backgroundStyle}
        />

        {/* <div
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage:
              'linear-gradient(rgba(255,255,255,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.08) 1px, transparent 1px)',
            backgroundSize: '72px 72px',
            opacity: 0.8,
          }}
        /> */}

        {Array.from({ length: gridRows }).map((_, rowIndex) =>
          Array.from({ length: gridCols }).map((_, colIndex) => {
            const isCurrent = currentCell?.row === rowIndex && currentCell?.col === colIndex;
            const isPrev = prevCell?.row === rowIndex && prevCell?.col === colIndex;
            return (
              <div
                key={`${rowIndex}-${colIndex}`}
                className="pointer-events-none absolute transition-colors duration-300"
                style={{
                  top: `${(rowIndex / gridRows) * 100}%`,
                  left: `${(colIndex / gridCols) * 100}%`,
                  width: `${100 / gridCols}%`,
                  height: `${100 / gridRows}%`,
                  backgroundColor: isCurrent
                    ? 'rgba(249, 115, 22, 0.5)'
                    : isPrev
                    ? 'rgba(38, 78, 162, 0.3)'
                    : 'transparent',
                  border: '1px solid rgba(255,255,255,0.02)',
                }}
              />
            );
          })
        )}

        {/* Content */}
        <h1 className="relative text-5xl sm:text-5xl md:text-7xl lg:text-9xl font-bold mb-4 md:mb-6 drop-shadow-lg">
          Qoncave
        </h1>

        <div className="relative rounded-lg h-1.5 w-40 bg-orange-500 mb-6 mt-4"></div>

        <p className="relative sm:text-base md:text-lg lg:text-xl max-w-xs sm:max-w-md md:max-w-3xl mx-auto mb-4 md:mb-8">
          Welcome to Qoncave, where creativity meets craftsmanship. Our expertise covers premium interior and exterior designs focused on modern aesthetics and timeless elegance. With precision and quality, we bring your unique style to life, ensuring every detail shines.
        </p>
        <button
          onClick={scrollToNextSection}
          className="relative bg-orange-500 text-white font-bold py-2 px-4 sm:py-3 sm:px-6 rounded hover:bg-gray-200 transition"
        >
          Read More
        </button>
      </div>

      {/* Placeholder for the Next Section */}
      <div
        id="next-section"
        className="flex justify-center items-center bg-gray-100 px-4 sm:px-6 lg:px-8 dark:bg-slate-900"
      >
        <About />
      </div>
    </div>
  );
};

export default Home;
